import { Component, Injector } from '@angular/core';
import { TierAware } from '../tier-aware.component';
import { Tier } from '../../models';
import { APPLY_DELIVERY_UPCHARGE } from '../../constants';

@Component({
  selector: 'app-delivery-price-message',
  templateUrl: './delivery-price-message.component.html',
  styleUrl: './delivery-price-message.component.scss',
})
export class DeliveryPriceMessageComponent extends TierAware {
  configurationDialogVisible: boolean = false;
  tier!: Tier;

  automaticDeliveryConfiguration: boolean = false;

  constructor(injector: Injector) {
    super(injector);
  }

  override afterTierChange(tier: Tier) {
    this.tier = tier;
    this.automaticDeliveryConfiguration =
      (tier.priceTierDocument?.configurations?.find(
        (config) => config.key == APPLY_DELIVERY_UPCHARGE,
      )?.value as boolean) || false;
  }

  openConfigurationDialog() {
    this.configurationDialogVisible = true;
  }
}
